import React from "react";
import { useTranslation } from "react-i18next";

const LoginText = () => {
  const { t } = useTranslation();
  return (
    <div className="text-white text-center">
      <p>{t("login.notice1")}</p>
      <p>{t("login.notice2")}</p>
      <p>{t("login.notice3")}</p>
    </div>
  );
};

export default LoginText;
